import { PercentageBar } from '../../../../../../components/barchart/bars/percentage-bar';
import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import './risk-profile.scss';
import { RiskProfile } from 'azshared/build/main/lib/model/wallet/wallet-ow';
import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody } from '@mui/material';
import { riskProfileErColumns } from 'azshared/build/main/lib/model/wallet/risk-profile-table-er/risk-profile-table-er';
import { AppTableCellHeader } from '../../../../../../components/table/table-cell-header';
import { Loader, LoaderSize } from '../../../../../../components/loader/loader';
import { AppTableCell } from '../../../../../../components/table/table-cell';
import { labelsForRiskProfileTable, walletErDetailPageMessages } from 'azshared';
import { AppSvgIcon } from '../../../../../../components/svg-icon/app-svg-icon';

export interface ErRiskProfileProps {
  profile: RiskProfile;
  isLoading: boolean;
}

export const ErRiskProfile = (props: ErRiskProfileProps) => {
  const { formatMessage } = useIntl();
  const { profile, isLoading } = props;

  return (

    <Fragment>
      <TableContainer className='er-detail-table'>
        <Table aria-label={'table'}>
          <TableHead>
            <TableRow>
              {riskProfileErColumns.map((column, index) => (
                <AppTableCellHeader key={'er-risk-profile-' + index} className={'er-detail-table-header'}>
                  {formatMessage(column.headerLabel)}
                </AppTableCellHeader>
              ))}
            </TableRow>
          </TableHead>
          {isLoading && (
            <TableBody>
              <TableRow>
                <TableCell colSpan={riskProfileErColumns.length + 1}>
                  <div className='table-loader'>
                    <Loader loadersize={LoaderSize.XL} />
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
          {!isLoading && (
            <TableBody>
              {profile.checks.map((check, index) => {
                const start = check.type === 'esg' ? check.thresholdValue : 0;
                const end = check.type === 'esg' ? 1 : check.thresholdValue;
                const step = check.type === 'esg' ? 1 - check.thresholdValue : check.thresholdValue;
                const range = end - start;
                const ratio = range === 0 ? 0 : (check.value - start) / range;
                const visualPercentage = Math.max(0, Math.min(100, ratio * 100));

                return (
                  <TableRow key={index} className='er-detail-table-row'>
                    <AppTableCell key={'type'} align={'left'} type={'string'}>
                      {formatMessage(labelsForRiskProfileTable(check.type).name)}
                      {check.type === 'investableResidual' && (
                        <span>
                          <sup>{'3'}</sup>
                        </span>
                      )}
                    </AppTableCell>
                    <AppTableCell key={'description'} align={'left'} type={'string'}>
                      {formatMessage(labelsForRiskProfileTable(check.type).description)}
                    </AppTableCell>
                    <TableCell key={'value'} colSpan={2}>
                      <PercentageBar
                        showValue
                        formatted
                        isPercentage
                        percentage={check.value}
                        visualPercentage={visualPercentage}
                        start={start}
                        end={end}
                        step={step}
                        title={''}
                      />
                    </TableCell>
                    <AppTableCell key={'result'} align={'center'} type={'react-node'}>
                      {check.isLimitRespected ? <AppSvgIcon icon={'ok'} /> : <AppSvgIcon icon={'ko'} />}
                    </AppTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {!isLoading && (
        <div className='er-detail-table-disclaimer'>
          <p className='er-detail-table-disclaimer-text'>{formatMessage(walletErDetailPageMessages.residuoInvestibileDisclaimer)}</p>
        </div>
      )}
    </Fragment>
  );
};
